import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { locales } from '../../services/language.service';
import { Organization } from '../../sdk';

@Component({
  selector: 'app-translatable-input',
  templateUrl: './translatable-input.component.html',
  styleUrls: ['./translatable-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslatableInputComponent implements OnInit {
  @Input() activeLocale: string;
  @Input() activeLocaleFlag: string;
  @Input() activeOrg: Organization;
  @Input() data: any = {};
  @Input() form: FormGroup;
  @Input() name: string;
  @Input() sent = false;
  @Output() changeLocale = new EventEmitter<any>();
  l10n: any[] = [];
  locales = locales;

  constructor(private fb: FormBuilder) {}

  hasError(type: string): boolean {
    return this.form.controls[this.name].hasError(type);
  }

  ngOnInit(): void {
    let group = this.form.get('l10n') as FormGroup;
    const localeShort = this.activeOrg.locale.split('-')[0];

    const currIdx = this.locales.findIndex(
      (l) => {
        return l.symbol === localeShort;
      }
    );
    let currentLocale = this.locales[currIdx];

    if (currentLocale) {
      this.locales = [
        currentLocale,
        ...this.locales.slice(0, currIdx),
        ...this.locales.slice(currIdx + 1),
      ];
    } else {
      currentLocale = { symbol: localeShort, name: 'default', flag: localeShort };

      // add unknown locale as default
      this.locales = [
        currentLocale,
        ...this.locales,
      ]
    }

    this.activeLocale = currentLocale.symbol;
    this.activeLocaleFlag = currentLocale.flag;

    if (!group) {
      this.form.addControl('l10n', this.fb.group({}));
      group = this.form.get('l10n') as FormGroup;
    }

    for (const locale of this.locales) {
      if (locale.symbol === this.activeOrg.locale.split('-')[0]) {
        continue;
      }

      this.l10n.push(locale.symbol);

      const localeKey = `${this.name}_${locale.symbol}`;

      group.addControl(localeKey, this.fb.control(''));
    }

    group.patchValue(this.data.l10n || {});
  }

  onSelectInputLocale(lang: any): void {
    if (lang.symbol === this.activeLocale) {
      return;
    }

    this.activeLocale = lang.symbol;
    this.activeLocaleFlag = lang.flag;
    this.changeLocale.emit(lang);
  }

  get l10nCtrl(): FormControl {
    return this.form.get('l10n') as FormControl;
  }
}
